module.exports = __webpack_public_path__ + "img/pf.8d7b9b71.png";